import InfiniteScrollContent from "@/components/InfiniteScrollContent";
import { pxtorem } from "@/utils/pxtorem";
import useNavigation from "@/utils/useNavigate";
import { ActivityModel, ProductModel } from "@akc/biz-api";
import { ItemType } from "@akc/biz-logic";
import { ActivityCardNormalV2Comp, ConferenceCard11Comp, ProductCard11SampleComp } from "@akc/mx-taro-h5-components";
import { InfiniteScroll, Popup } from "antd-mobile";
import React, { useEffect, useState } from "react";
import { useMoreProductList } from "./hooks/useMoreProductList";
import styles from "./index.module.less";

interface PrdActivityPopupProps {
  /**
   * 关联商品、档期的查询依据
   * "PRODUCT" 根据商品查询，适用于商品视频大卡
   * "MATERIAL" 根据素材查询，适用于素材视频大卡
   */
  queryBy?: "PRODUCT" | "MATERIAL";
  // 当前商品activitySpuId，当queryBy为"PRODUCT"时必传
  activitySpuId?: string;
  // 当前视频素材编号
  materialNo?: string;
  trackDataCommon?:{page_name?: string,  domain?: string}
  onClose: () => void;
  onProductClick?: (product: ProductModel) => void;
  onBuyAction?: (product: ProductModel) => void;
  onAddCartAction?: (product: ProductModel) => void;
  onForwardaPrdAction?: (product: ProductModel) => void;
  onConferenceClick?: (conference: any,index: number) => void;
}

const PrdActivityPopup: React.FC<PrdActivityPopupProps> = ({
  queryBy="PRODUCT",
  activitySpuId,
  materialNo,
  trackDataCommon,
  onClose,
  onProductClick,
  onBuyAction,
  onAddCartAction,
  onForwardaPrdAction,
  onConferenceClick,
}) => {
  const { navigate2Cart, navigate2Product, navigate2H5, navigate2SuperVenue,  navigate2Venue,navigate: navigater,navigate2Activity } = useNavigation();
  const [curTab, setCurTab] = useState(0);

  const {
    productList,
    hasMorePrd,
    handleMoreProductList,
    prdSearchRequestIdRef,
    activityList,
    handleMoreActivityList,
    activitySearchRequestIdRef,
    tabs,
  } = useMoreProductList({
    queryBy,
    activitySpuId,
    materialNo,
  });

  useEffect(() => {
    // 初始化加载
    // handleMoreProductList();//InfiniteScroll支持分页，InfiniteScroll会自动初始加载一次，所以这里注释
    handleMoreActivityList();
  }, []);


  
  // 切换tab
  const changeTab = (index: number) => {
    if (index !== curTab) {
      const dom: any = document.getElementById("popup_tabs_content");
      if (dom) {
        dom.scrollTop = 0;
      }
    }
    setCurTab(index);
  };



  const onCartClick = () => {
    navigate2Cart();
    onClose();
  };

  
  // 活动点击处理
  // const handleActivityClick = (activity: any) => {
  //   navigate2H5(activity.ringshopLinkUrl);
  // };


  const getTabContentFragment = () => { 
    const crtTabKey=tabs[curTab]?.key;
    // 活动tab
    if(crtTabKey === "ACTIVITY") {
      return (
        <div className={styles.activityList}>
          {/* 档期列表 */}
          {activityList.map((item, index) => {
            // 档期卡片
            if(item.cardType === "ACTIVITY"){
              return (
                <div key={index} className={styles.activityItem} >
                  <ActivityCardNormalV2Comp
                    model={item}
                    entryBtnName="去逛逛"
                    trackData={{
                      page_name: trackDataCommon?.page_name,
                      domain: trackDataCommon?.domain,
                      module: "商品口袋",
                      search_request_id: activitySearchRequestIdRef.current,
                    }}
                    mainLocationCode="H5_ScheduleList_BrandDown"
                    productTLLocationCode="H5_ScheduleList_TopProductPicLeft"
                    productTRLocationCode="H5_ScheduleList_TopProductPicRight"
                    goActivityDetail={activity => {
                      navigate2Activity({ activityNo: activity.activityId });
                      onClose();
                    }}
                    goProductDetail={(product) => {
                      navigate2Product({
                        activityId: product.activityId,
                        activitySpuId: product.activitySpuId,
                        selectSkuId: product.selectSkuId,
                      });
                      onClose();
                    }}
                  />
                </div>
              );
            }
            // 会场卡片
            return (
              <div key={index} className={styles.conferenceItem}>
                <ConferenceCard11Comp
                  key={index}
                  conference={item}
                  btnName="去逛逛"
                  trackData={{
                    page_name: trackDataCommon?.page_name,
                    domain: trackDataCommon?.domain,
                    module: "商品口袋",
                    search_request_id: activitySearchRequestIdRef.current,
                  }}
                  onConferenceClick={(conference) => {
                    navigater({
                      h5Options: {
                        url: `/mx-shop-micro?customPageCode=${conference.pageCode}`,
                      },
                    });
                    onClose();
                  }}
                />
              </div>
            );
          })}
        </div>
      );
    }
    // 否则默认商品tab
    return (
      <div className={styles.productList}>
        {productList.map((product, index) => (
          <ProductCard11SampleComp
            key={product.activitySpuId}
            titleFrontLocationCode="H5_ProductList_styleNo1_titleFront"
            titleBottomLocationCode="H5_ProductList_styleNo1_titleDown"
            product={product}
            onProductClick={() => {
              onProductClick?.(product);
              onClose();
            }}
            onBuyClick={() => {
              onBuyAction?.(product);
              onClose();
            }}
            onAddCartClick={() => {
              onAddCartAction?.(product);
              onClose();
            }}
            onForwardClick={() => {
              onForwardaPrdAction?.(product);
              onClose();
            }}
            className={styles.videoCardComp}
            trackData={{
              page_name: trackDataCommon?.page_name,
              domain: trackDataCommon?.domain,
              module: "商品口袋",
              resource_rank: index + 1,
              search_request_id: prdSearchRequestIdRef.current,
            }}
          />
        ))}
        <InfiniteScroll loadMore={handleMoreProductList} hasMore={hasMorePrd} threshold={0}>
          <InfiniteScrollContent hasMore={hasMorePrd} />
        </InfiniteScroll>
      </div>
    );
  };
  


  return (
    <Popup
      getContainer={() => document.body}
      visible
      onMaskClick={onClose}
      onClose={onClose}
      bodyStyle={{
        height: "80vh",
        backgroundColor: "#F1F2F5",
        padding: 0,
        boxSizing: "border-box",
        borderRadius: "0.32rem 0.32rem 0 0",
      }}
    >
      <div>
        {/* 头部tabs */}
        <div className={styles.header}>
          {tabs.length>1 ? (
            <div className={styles.tabs}>
              {tabs.map((tab,index) => (
                <div
                  key={tab.key}
                  onClick={() => changeTab(index)}
                  className={styles.tabItem + " " + (curTab === index ? styles.active : "")}>
                  {tab.title}
                </div>
              ))}
            </div>
          ) : (
            <div className={styles.title_single_tab}>{tabs[0]?.title}</div>
          )}
          <img
            onClick={onCartClick}
            className={styles.cart}
            src="https://akim-oss.aikucun.com/2a7c84eb10a41cafd09088bc22f158c99b7e44e9_1751353398232_62.png"
            alt=""
          />
        </div>
        
        {/* tab内容 */}
        <div
          id="popup_tabs_content"
          className={styles.content}>
          {getTabContentFragment()}
        </div>
      </div>
    </Popup>
  );
};

export default PrdActivityPopup;
